import { App } from "../../types/app";

const byNameThenId = (a: App, b: App): number => {
  const byName = a.name.localeCompare(b.name, undefined, { sensitivity: "base" });
  return byName !== 0 ? byName : a.id.localeCompare(b.id);
};

// The switcher's order: the Home Workspace first (the Home Record's "app-id", system:#home), then the
// caller's favorites alphabetically (case-insensitive, app id as the tie-break), then every other app in
// the order get-apps returned them (lowest app id first, query-omega-oql user-apps.oql Qo.UserApps/apps!).
// Home appears once even when it is also a favorite; favorite ids that are not in the list are ignored.
// Never mutates its input.
export const orderWorkspaces = (
  apps: App[],
  homeApp: string | undefined,
  favoriteAppIds: string[] = []
): App[] => {
  const home = homeApp ? apps.find((app) => app.id === homeApp) : undefined;
  const favoriteIds = new Set(favoriteAppIds);
  const favorites = apps
    .filter((app) => app.id !== home?.id && favoriteIds.has(app.id))
    .sort(byNameThenId);
  const rest = apps.filter(
    (app) => app.id !== home?.id && !favoriteIds.has(app.id)
  );
  return [...(home ? [home] : []), ...favorites, ...rest];
};

// Kept for existing callers: homeFirst is orderWorkspaces with no favorites.
export const homeFirst = (apps: App[], homeApp: string | undefined): App[] =>
  orderWorkspaces(apps, homeApp, []);
